import { useLogin } from '../components/Login/useLogin'
import { LoginForm } from '../components/Login/LoginForm'
import { Shield } from 'lucide-react'

export default function Login() {
  const devBypass = import.meta.env.VITE_DEV_BYPASS_OTP === 'true'
  const { login, loading, error } = useLogin()

  const defaultValues = {
    email: devBypass ? 'admin@satyanand.com' : '',
    password: devBypass ? '9999999999' : '',
  }

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950 font-sans antialiased selection:bg-blue-500/30">
      {/* Dynamic Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_20%,#1d4ed8_0%,transparent_35%),radial-gradient(circle_at_85%_10%,#059669_0%,transparent_30%),radial-gradient(circle_at_50%_95%,#0ea5e9_0%,transparent_35%)] opacity-30 animate-pulse" />
      <div className="absolute left-10 top-12 h-96 w-96 rounded-full border-2 border-white/5 animate-pulse" />
      <div className="absolute bottom-10 right-8 h-80 w-80 rounded-full border-2 border-white/5 animate-pulse" />

      <div className="relative mx-auto grid min-h-screen w-full max-w-6xl grid-cols-1 items-center gap-12 px-6 py-20 lg:grid-cols-2">
        {/* Left Side: Brand & Mission */}
        <div className="hidden text-white lg:block animate-in fade-in slide-in-from-left-8 duration-1000">
          <div className="inline-flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-5 py-2.5 text-xs font-black uppercase tracking-widest backdrop-blur-3xl shadow-2xl">
            <Shield className="h-4 w-4 text-emerald-400" />
            Satyanand Research Institute
          </div>
          <h1 className="mt-10 text-6xl font-black leading-[1.1] tracking-tighter text-transparent bg-clip-text bg-gradient-to-br from-white to-slate-500">
            Secure Admin Panel
          </h1>
          <p className="mt-8 max-w-md text-lg text-slate-400 font-medium leading-relaxed">
            Secure access to the user management, course management and many
            more features.
          </p>
          <div className="mt-12 h-px w-32 bg-gradient-to-r from-blue-500/50 to-transparent" />
        </div>

        {/* Right Side: Authentication */}
        <div className="flex justify-center items-center">
          <LoginForm
            onSubmit={login}
            loading={loading}
            error={error}
            defaultValues={defaultValues}
          />
        </div>
      </div>
    </div>
  )
}
